<template>
  <div class="carbonIndex">
    <h2 class="sr-only">碳匯專區</h2>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "carbonIndex"
};
</script>
<style lang="scss" scoped>
.carbonIndex {
  height: inherit;
}
</style>
